import React, { useCallback, useState } from "react";
import moment from "moment";

import EditModal from "./Edit/Edit";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function SymbolCard({ item, user_id, loadSymbolQty }) {
  const userType = Number(localStorage.getItem("user_type") || 7);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const cellStyle = {
    flex: 1,
    textAlign: "center",
    fontWeight: 600,
    color: "var(--text)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: 12,
  };

  const buttonStyle =
    "relative  flex items-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 border-2 text-white border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)] cursor-pointer hover:opacity-80";

  // check if symbol is allowed
  const isAllowed = item.allow == 1; // change this field according to your DB
  const isBlock = item.block == 1; // change this field according to your DB

  const performAction = useCallback(
    async (endpoint) => {
      if (loading) return;

      setLoading(true);

      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id,
        symbol_name: item.symbol_display,
        symbol_id: item.symbol_id,
        symbol_type: item.type,
      };

      const result = await backend[endpoint](payload);
      setLoading(false);

      if (result.error === "False") {
        toast.success(result.message);
        loadSymbolQty();
      } else {
        toast.error(result.message || "Action failed");
      }
    },
    [loading, item, user_id]
  );

  const handleReset = () => performAction("reset_symbol");

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        borderBottom: `2px solid var(--hover)`,
        height: 40,
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
        backgroundColor: !isAllowed ? "#f8f8f8" : "transparent",
      }}
    >
      {/* Overlay if symbol is not allowed */}
      {!isAllowed && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 150, // leave space for Edit button
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.55)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 14,
            color: "white",
            textTransform: "uppercase",
            pointerEvents: "none",
          }}
        >
          🚫 Not Allowed
        </div>
      )}

      {/* Blocked Overlay (only covers row data, not edit button) */}
      {isBlock && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 150, // leave space for Edit button (~80px wide)
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.55)", // dark overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 14,
            color: "white",
            textTransform: "uppercase",
            pointerEvents: "none", // allow click-through to Edit
          }}
        >
          🚫 Blocked
        </div>
      )}

      {/* Row Data */}
      <div style={{ ...cellStyle, flex: 1 }}>{item.symbol_display}</div>
      <div style={{ ...cellStyle, flex: 1 }}>
        {moment(item.expiry_date).format("DD-MMM")}
      </div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.min_qty}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.qty_per_order}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.total_quantity}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.lot_size}</div>
      <div style={{ ...cellStyle, flex: 1 }}>{item.margin}</div>

      {/* Edit Button (always visible) */}
      <div
        style={{
          ...cellStyle,
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2,
        }}
      >
        {item.edit == 1 ? (
          <div
            onClick={() => (userType === 5 || userType === 6) ? null : handleReset()}
            className={buttonStyle}
            style={{
              marginLeft: 5,
              backgroundColor: "var(--sell)",
            }}
          >
            RESET
          </div>
        ) : (
          <div
            onClick={() => (userType === 5 || userType === 6) ? null : setIsEditModalOpen(true)}
            className={buttonStyle}
            style={{
              marginLeft: 5,
              backgroundColor: "var(--primary)",
            }}
          >
            EDIT
          </div>
        )}
      </div>

      {/* Edit Modal */}
      <EditModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        item={item}
        user_id={user_id}
        fetchSymbol={loadSymbolQty}
      />
    </div>
  );
}
